module.exports = __webpack_public_path__ + "static/media/header-logo.01235f03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header-logo.png
// module id = 411
// module chunks = 33